import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    referees: [],
    tournaments: [],
    matches: [],
    currentMatch: null,
    loading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
    },
};

const refereeSlice = createSlice({
    name: 'referee',
    initialState,
    reducers: {
        setReferees: (state, action) => {
            state.referees = action.payload;
        },
        setTournaments: (state, action) => {
            state.tournaments = action.payload;
        },
        setMatches: (state, action) => {
            state.matches = action.payload;
        },
        setCurrentMatch: (state, action) => {
            state.currentMatch = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        updateScore: (state, action) => {
            if (state.currentMatch) {
                state.currentMatch.score = action.payload;
            }
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const {
    setReferees,
    setTournaments,
    setMatches,
    setCurrentMatch,
    setPagination,
    setLoading,
    setError,
    updateScore,
    clearError,
} = refereeSlice.actions;

export default refereeSlice.reducer;
